import { html, classMap } from '@resn/gozer-core';
import { autobind } from 'core-decorators';

import { Component, componentMixin } from '@resn/gozer-core/component';
import { PAGE_DATA } from 'data/page-data';

import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import WithRouter from '@resn/gozer-core-mixins/with-router';
import Analytics from '@resn/gozer-core/analytics';

import './index.scss';
import store from 'core/store';
import ResizeService from '@resn/gozer-services/resize-service';

import MenuPanel from './panel';
import OxeSubHeader from './oxe-sub-header';
import { navigate } from 'utils/router-utils';
import Header from './header';
import PromoBanner from './promo-banner';

const template = ({ props, context }) => html` <div class="menu ${classMap({ open: props.open })}"></div> `;

@componentMixin(WithRouter)
@componentMixin(DomComponentMixin)
class Menu extends Component {
    options = {
        template,
    };

    props = {
        open: false,
        visible: false,
        scrolling: false,
        page: () => store().state.route.page,
        extended: () => store().state.menu.open,
        aboveFold: () => store().state.scroll < ResizeService.windowHeight,
    };

    @autobind
    onClick() {}

    async onSetup() {
        await this.createHeader();
        await this.createPanel();
        await this.createSubHeader();
        if (store().state.showPromoBanner) await this.createPromoBanner();

        // this.addListeners();
    }

    async createHeader() {
        this.header = await new Header().setup({
            options: {
                appendTo: this.el,
                navigateTo: this.navigateTo,
                onMenu: () => {
                    this.props.open = true;
                    Analytics.trackEvent('Header', 'click', 'Menu Button');
                },
                onClose: () => {
                    this.props.open = false;
                },
            },
            props: {
                open: () => this.props.open,
                visible: () => this.props.visible,
            },
        });
    }

    async createPanel() {
        this.panel = await new MenuPanel().setup({
            options: {
                appendTo: this.el,
                navigateTo: this.navigateTo,
            },
            props: {
                open: () => this.props.open,
            },
        });
    }

    async createSubHeader() {
        this.oxeSubHeader = await new OxeSubHeader().setup({
            options: {
                appendTo: this.el,
            },
            props: {
                pointerOverLink: () => this.header.center.linkSolutions.props.pointerOver,
            },
        });
    }
    async createPromoBanner() {
        this.promoBanner = await new PromoBanner().setup({
            options: {
                appendTo: this.el,
            },
        });
    }

    // addListeners() {
    // window.addEventListener('mousewheel', this.onMouseWheel);
    // MouseService.add('down', this.onDown);
    // }

    // @autobind
    // onMouseWheel() {
    //     this.preventScrolling();
    // }
    // @autobind
    // onDown() {
    //     this.preventScrolling();
    // }

    // preventScrolling() {
    //     if (this.props.scrolling) {
    //         gsap.killTweensOf(ScrollService, 'scroll');
    //         this.props.scrolling = false;
    //     }
    // }

    // state ----------------------------------------------

    onOpen() {}
    offOpen() {}

    // handlers ----------------------------------------------

    @autobind
    navigateTo(route) {
        navigate(route);
        this.props.open = false;
    }

    resize() {
        this.header.resize();
        this.oxeSubHeader.resize();
    }
}

export default Menu;
